import { BrokerStatus, StatusForBroker, UPDATEABLE_BROKER_STATUSES, UpdateableBrokerStatus } from "@dune/types";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@dune/ui";
import { brokerStatusStyles } from "@dune/utils";
import { ChevronDown } from "lucide-react";

const isSelectableStatus = (
	status: BrokerStatus,
): status is UpdateableBrokerStatus =>
	UPDATEABLE_BROKER_STATUSES.includes(status as UpdateableBrokerStatus);

interface BrokerStatusSelectProps {
	status: BrokerStatus;
	onStatusChange: (status: BrokerStatus) => void;
	isLoading?: boolean;
}

export const BrokerStatusSelect = ({
	status,
	onStatusChange,
	isLoading = false,
}: BrokerStatusSelectProps) => {
	if (!isSelectableStatus(status)) {
		return (
			<span
				className={`px-2 py-1 rounded-full text-xs font-medium border ${brokerStatusStyles[status]}`}
			>
				{StatusForBroker[status]}
			</span>
		);
	}

	const otherStatus = status === "PROGRESS" ? "CANCELLED" : "PROGRESS";

	return (
		<DropdownMenu>
			<DropdownMenuTrigger
				disabled={isLoading}
				className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium border cursor-pointer transition-opacity ${brokerStatusStyles[status]} ${isLoading ? "opacity-50 cursor-not-allowed" : "hover:opacity-80"}`}
			>
				{StatusForBroker[status]}
				<ChevronDown className="w-3 h-3" />
			</DropdownMenuTrigger>
			<DropdownMenuContent align="start">
				<DropdownMenuItem
					className="text-xs font-medium cursor-pointer"
					onClick={() => onStatusChange(otherStatus)}
				>
					<span
						className={`px-2 py-0.5 rounded-full border ${brokerStatusStyles[otherStatus]}`}
					>
						{StatusForBroker[otherStatus]}
					</span>
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
